import { RootState } from "../../../store";
import { LiveUsageMgmtSlice } from "../../liveUsageMgmtSlice";

export const liveUsageMgmtSliceSelector = (
  state: RootState,
): LiveUsageMgmtSlice => state.liveUsageMgmt;
